import Vue from 'vue'
import VueI18n from 'vue-i18n'
import _en from './en'
import _cn from './cn'
import _td from './td'
import _spa from './spa'
import _rus from './rus'

Vue.use(VueI18n)

let en = getObject(_en)
let cn = getObject(_cn)
let td = getObject(_td)
let spa = getObject(_spa)
let rus = getObject(_rus)

function getObject (obj) {
  let langObj = {}
  Object.keys(obj).forEach(i => {
    let temp = {...obj[i]}
    langObj = Object.assign(langObj, temp)
  })
  return langObj
}

let messages = {
  en, cn, td, rus, spa
}

const i18n = new VueI18n({
  locale: 'cn',
  messages
})

export default i18n



// WEBPACK FOOTER //
// ./src/i18n/index.js